import ExecAPI from 'appRoot/api/api';

/**
 * Gets the current registration/health status of every managed instance in every managed target group, along with
 * the deregistration delay (drain time) configuration.
 */
export function GetAwsMaintenanceStatus()
{
	return ExecAPI("AwsMaintenance/GetAwsMaintenanceStatus");
}
/**
 * Registers a managed instance with every managed target group.  Also serves to repair a partial registration and
 * to cancel an in-progress deregistration (a draining target returns to service once it passes health checks).
 * @param {String} instanceId EC2 instance ID.
 */
export function RegisterAwsMaintenanceInstance(instanceId)
{
	return ExecAPI("AwsMaintenance/RegisterAwsMaintenanceInstance", { instanceId });
}
/**
 * Deregisters a managed instance from every managed target group.  The server refuses if any target group would be
 * left without at least one other healthy target.
 * @param {String} instanceId EC2 instance ID.
 */
export function DeregisterAwsMaintenanceInstance(instanceId)
{
	return ExecAPI("AwsMaintenance/DeregisterAwsMaintenanceInstance", { instanceId });
}
/**
 * Assigns the preferred default deregistration delay (drain time), storing it in TdsAppService settings and
 * committing it to every managed target group.
 * @param {Number} seconds Drain time in seconds (0-3600).
 */
export function SetAwsMaintenanceDefaultDrain(seconds)
{
	return ExecAPI("AwsMaintenance/SetAwsMaintenanceDefaultDrain", { seconds });
}
/**
 * Assigns the drain time override that applies only to deregistration actions performed via the AWS Maintenance
 * page.  Stored in TdsAppService settings.
 * @param {Number} seconds Drain time in seconds (0-3600), or -1 to disable the override.
 */
export function SetAwsMaintenanceActionDrain(seconds)
{
	return ExecAPI("AwsMaintenance/SetAwsMaintenanceActionDrain", { seconds });
}
